import { useFormField } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { useState, useCallback } from 'react'
import { useSelector } from 'react-redux'

import { usePublisherWorkflowsModalT } from 'features/workflows/modals/use_publisher_workflows_modal_t'
import {
  combinedTriggerTypeSelector,
  workflowRuleTimeValueSelector,
  workflowRuleTimeUnitsSelector
} from 'selectors/workflows'

import { TriggerEdit } from '../controls/trigger_edit'

export const EditWhenThisHappens = ({ isOpen, onClose }) => {
  const wfT = usePublisherWorkflowsModalT()
  const currentTriggerType = useSelector(combinedTriggerTypeSelector)
  const currentTimeValue = useSelector(workflowRuleTimeValueSelector)
  const currentTimeUnits = useSelector(workflowRuleTimeUnitsSelector)
  const [triggerType, setTriggerType] = useState(currentTriggerType)
  const [timeValue, setTimeValue] = useState(currentTimeValue)
  const [timeUnits, setTimeUnits] = useState(currentTimeUnits)
  const [triggerHasError, setTriggerHasError] = useState(false)

  const handleClose = useCallback(() => {
    setTriggerType(currentTriggerType)
    setTimeValue(currentTimeValue)
    setTimeUnits(currentTimeUnits)
    onClose()
  }, [currentTriggerType, currentTimeUnits, currentTimeValue, onClose])

  function onChange(_triggerType, value, units) {
    setTriggerType(_triggerType)
    setTimeValue(value)
    setTimeUnits(units)
  }

  const [{ value },, { setValue, setTouched }] = useFormField({ name: 'workflow_rule' })

  function onConfirm() {
    if (triggerHasError) return

    const [type, trigger, eventName] = triggerType.split('.')
    const payload = { type, trigger, eventName }

    setValue({
      ...value,
      event_name: payload.eventName,
      trigger_type: payload.trigger,
      time_value: timeValue,
      time_units: timeUnits
    }, true)
    setTouched(true)

    onClose()
  }

  return (
    <SimplePopup
      isOpen={isOpen}
      onClose={handleClose}
      title={wfT('publisher.workflows.builder_form.edit_trigger.title')}
      cancelLabel={I18n.t('publisher.action.cancel')}
      confirmLabel={I18n.t('publisher.action.done')}
      onConfirm={onConfirm}
    >
      <TriggerEdit
        triggerType={triggerType}
        timeValue={timeValue}
        timeUnits={timeUnits}
        onChange={onChange}
        onError={setTriggerHasError}
      />
    </SimplePopup>
  )
}
